import { render } from "./PlanStep1.vue?vue&type=template&id=49b4adef&scoped=true"
import script from "./PlanStep1.vue?vue&type=script&lang=js"
export * from "./PlanStep1.vue?vue&type=script&lang=js"

import "./PlanStep1.vue?vue&type=style&index=0&id=49b4adef&scoped=true&lang=stylus"
import "./PlanStep1.vue?vue&type=style&index=1&id=49b4adef&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b4adef"]])

export default __exports__